import React from 'react';
import './CeoMessage.css';

const CeoMessage = () => {
    return (
        <section className="ceo-message-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h2 className="section-title">Message From The CEO</h2>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-lg-4">
                        <div className="ceo-image">
                            <img 
                                src="/assets/images/avatar/talha.jpg" 
                                alt="CEO" 
                                className="img-fluid rounded-circle"
                            />
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="ceo-content">
                            <p className="message">
                                "At <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span>, we believe in transforming how businesses operate in the digital age. Our commitment to connecting exceptional talent with forward-thinking companies has created countless success stories. We're not just providing staffing solutions; we're building lasting partnerships that drive growth and innovation."
                            </p>
                            <div className="ceo-signature">
                                <h4>John Smith</h4>
                                <p>CEO & Founder</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CeoMessage;